module.exports = __webpack_public_path__ + "static/img/role-en.2d4ccdc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-4/role-en.png
// module id = CcZ7
// module chunks = 1